const initialState = {
    directReportees: [],
    teamProfileTableData: []
};

export const MyTeamProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_UPG_MY_TEAM_PROFILE_TABLE_DATA' :
      return {
        ...state,
        teamProfileTableData: action.payload
      };
    case 'GET_UPG_MY_TEAM_PROFILE_POPUP_FILTER_DATA' :
      return {
        ...state,
        filterData: action.payload
      }
    case 'UPG_MY_TEAM_PROFILE_SAVE_RESPONSE' :
      return {
        ...state,
        saveResponse: action.payload
      }
    case 'GET_UPG_MY_TEAM_PROFILE_FILTERS' :
      return {
        ...state,
        myTeamFilterData: action.payload
      }
    case 'API_START' :
      if (action.payload === 'FETCH_MY_TEAM_PROFILE_TABLE_DATA' || action.payload === 'FETCH_MY_TEAM_PROFILE_POPUP_FILTER_DATA') {
        return {
          ...state,
          isLoadingMyTeamProfileFilterData: true,
        };
      } else {
        return state;
      }
    case 'API_END':
      if (action.payload === 'FETCH_MY_TEAM_PROFILE_TABLE_DATA' || action.payload === 'FETCH_MY_TEAM_PROFILE_POPUP_FILTER_DATA') {
        return {
          ...state,
          isLoadingMyTeamProfileFilterData: false,
        };
      } else {
        return state;
      }

    default:
        return state;
  }
};
